import { render, staticRenderFns } from "./mdxf-record.vue?vue&type=template&id=50aba14e&"
import script from "./mdxf-record.vue?vue&type=script&lang=js&"
export * from "./mdxf-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports